import walletApi from './walletApi';

const API_BASE = '/api';

// Authenticated admin API
const offerApi = {
  create: (data) => walletApi.post('/offer-letters/create', data).then(r => r.data),
  send: (id) => walletApi.post(`/offer-letters/${id}/send`).then(r => r.data),
  list: (status) => walletApi.get('/offer-letters/list', { params: status ? { status } : {} }).then(r => r.data),
  detail: (id) => walletApi.get(`/offer-letters/detail/${id}`).then(r => r.data),
  stats: () => walletApi.get('/offer-letters/stats').then(r => r.data),
  resend: (id) => walletApi.post(`/offer-letters/${id}/resend`).then(r => r.data),
  downloadPdf: (id) => walletApi.get(`/offer-letters/detail/${id}/pdf`, { responseType: 'blob' }),
};

// Public (no auth) API for candidates
const offerPublicApi = {
  get: (token) => fetch(`${API_BASE}/offer-letters/public/${token}`).then(r => r.json()),
  selectBenefits: (token, selections) =>
    fetch(`${API_BASE}/offer-letters/public/${token}/select-benefits`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ selections }),
    }).then(r => r.json()),
  accept: (token, data) =>
    fetch(`${API_BASE}/offer-letters/public/${token}/accept`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    }).then(r => r.json()),
  decline: (token) =>
    fetch(`${API_BASE}/offer-letters/public/${token}/decline`, { method: 'POST' }).then(r => r.json()),
  calculateTax: (token, benefitsAmount) =>
    fetch(`${API_BASE}/offer-letters/public/${token}/calculate-tax?benefits_amount=${benefitsAmount}`).then(r => r.json()),
};

export { offerApi, offerPublicApi };
